import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthUser } from '@/types/api.types';

interface AuthState {
  user: AuthUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  status: 'idle' | 'loading' | 'authenticated';
  setAuth: (user: AuthUser, accessToken: string, refreshToken: string) => void;
  clearAuth: () => void;
  updateUser: (partial: Partial<AuthUser>) => void;
}

// Tokens em localStorage são legíveis por JS — use CSP estrita (no inline-scripts,
// trusted origins) em produção para mitigar XSS. Alternativa: HttpOnly cookies.
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      status: 'idle',

      setAuth: (user, accessToken, refreshToken) =>
        set({ user, accessToken, refreshToken, status: 'authenticated' }),

      clearAuth: () =>
        set({ user: null, accessToken: null, refreshToken: null, status: 'idle' }),

      updateUser: (partial) =>
        set((s) => ({ user: s.user ? { ...s.user, ...partial } : null })),
    }),
    {
      name: 'auth',
      partialize: (s) => ({
        user: s.user,
        accessToken: s.accessToken,
        refreshToken: s.refreshToken,
        status: s.status,
      }),
    },
  ),
);
